import * as React from "react";
import { useState } from "react";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { CountryCode } from "../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { RoleStatus } from "../../../../../../Wrap/Constants/Enums/RoleStatus";
import { CustomerTaxResidencyModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { ITableConfig, Table } from "../../../../../Shared/Table/Table";
import { SectionHeader } from "../../NewBusinessWizard/Components/SharedComponents";
import { AccountRoleStore } from "../Store/Variable";
import { AddNewButton } from "./AddNewButton";

interface ITableViewSectionProps {
    sectionHeader: string;
    columnConfigs: ITableConfig[];
    lightboxContent: (data: CustomerTaxResidencyModel, onDataChange, isEdit) => JSX.Element | string;
    onSave?: (data) => boolean;
    onAdd?: (data) => boolean;
    onRemove?: (data) => boolean;
    getEmptyData?: any;
    data: CustomerTaxResidencyModel[];
    canEdit?: boolean;
    canAdd?: boolean;
    canRemove?: boolean;
}

export const TableViewSection = (props: ITableViewSectionProps) => {
    const [lightbox, setLightbox] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [currentFormData, setCurrentFormData] = useState(null);

    const onDataChange = (changes) => {
        const _data = JSON.parse(JSON.stringify(currentFormData));
        for (const key in changes) {
            _data[key] = changes[key];
        }
        setCurrentFormData(_data);
    };

    const addNew = () => {
        const newdata = props.getEmptyData ? props.getEmptyData() : {};
        setLightbox(true);
        setEditIndex(null);
        setCurrentFormData(newdata);
    };

    const editItem = (index, currentData) => {
        const _currentData = JSON.parse(JSON.stringify(currentData));
        setLightbox(true);
        setEditIndex(index);
        setCurrentFormData(_currentData);
    };

    const renderTable = () => {
        const col = props.columnConfigs.map((x) => x);
        if (AccountRoleStore.canEditForAdv()) {
            col.push({
                title: "",
                render: (ele, row, index) => {
                    return (
                        <>
                            {row?.AccountRoleStatus != RoleStatus.Inactive && (props.canEdit == null || props.canEdit) && (
                                <button
                                    className={"edit-circle-icon-button label-sr-only mr-2"}
                                    title="Edit"
                                    onClick={() => editItem(index, row)}
                                >
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text">Edit</span>
                                </button>
                            )}

                            {row?.Country != CountryCode.GBR && props?.canRemove != false && (
                                <button
                                    className="remove-button label-sr-only"
                                    title="Delete"
                                    disabled={false}
                                    onClick={() => props.onRemove(index)}
                                >
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text">Delete</span>
                                </button>
                            )}
                        </>
                    );
                },
            });
        }
        return <Table data={props.data} col={col} showEmptyMsg={true} />;
    };

    return (
        <>
            <div className="flex-space">
                {SectionHeader(props.sectionHeader)}
                {AccountRoleStore.canEditForAdv() && (
                    <>
                        {props.onAdd && (props.canAdd == null || props.canAdd) && (
                            <div className="mb-20">
                                <AddNewButton name="Add new" onClick={addNew} />
                            </div>
                        )}
                    </>
                )}
            </div>

            {renderTable()}

            {lightbox && (props.onAdd || props.onSave) ? (
                <Lightbox
                    cssWrapper="is-default-lightbox"
                    onClose={() => setLightbox(false)}
                    show={lightbox}
                    isClickOutsideClose={false}
                    title={props.sectionHeader}
                >
                    {props.lightboxContent(currentFormData, onDataChange, editIndex != null)}
                    <div className="row">
                        <div className="col-auto">
                            <button
                                className="btn secondary"
                                onClick={() => {
                                    setLightbox(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="col-auto">
                            <button
                                className="btn primary"
                                onClick={() => {
                                    if (editIndex != null) {
                                        if (props.onSave(currentFormData)) {setLightbox(false);}
                                    } else {
                                        if (props.onAdd(currentFormData)) {setLightbox(false);}
                                    }
                                }}
                            >
                                {editIndex != null ? "Save" : "Add"}
                            </button>
                        </div>
                    </div>
                </Lightbox>
            ) : null}
        </>
    );
};
